module.exports = __webpack_public_path__ + "static/media/framanverdlaeri_small.8fd36a03.png";